import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    roundId: "",
    projectId: "",
    isConfigurationSet: false,
    fileTypeRFP:true
}

export const newProjectRFPDetailsSlice = createSlice({
    name: "newProject-RFP-Details",
    initialState,
    reducers: {
        setNewProjectRFPDetail: (state, actions) => {
            state.projectId = actions.payload.projectId;
            state.roundId = actions.payload.roundId;
        },
        isConfigurationSet: (state, actions) => {
            state.isConfigurationSet = actions.payload
        },
        setFileTypeRFP:(state,actions)=>{
            state.fileTypeRFP=actions.payload;
        }

    }

})

export const { setNewProjectRFPDetail, isConfigurationSet,setFileTypeRFP } = newProjectRFPDetailsSlice.actions;
export default newProjectRFPDetailsSlice.reducer;
